import { z } from 'zod';
import { FlowDurationSchema } from '../../../duration/duration.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
const FlowAsynchronousJobBaseSchema = z.object({
    jobKind: z.string(),
    timeout: FlowDurationSchema,
});
export const FlowAsynchronousExtractJobBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.AsynchronousExtractJob),
    config: FlowAsynchronousJobBaseSchema,
});
//# sourceMappingURL=config.js.map